import { useState } from "react";
import { X } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const guides = [
{
title: "Asuransi Perjalanan Syariah",
content:
"Asuransi perjalanan memberikan perlindungan selama perjalanan ibadah apabila terjadi kondisi darurat, kebutuhan medis, maupun risiko perjalanan lainnya."
},
{
title: "Vaksin Meningitis",
content:
"Pastikan vaksin yang dipersyaratkan telah dipenuhi sesuai ketentuan yang berlaku sebelum keberangkatan."
},
{
title: "Pemesanan Slot Raudhah (Nusuk)",
content:
"Pemesanan slot Raudhah dilakukan melalui aplikasi Nusuk dan sangat disarankan dilakukan sebelum keberangkatan."
},
{
title: "Passport",
content:
"Paspor harus memiliki masa berlaku minimal 6 bulan sejak tanggal keberangkatan."
},
{
title: "Tiket Pesawat",
content:
"Pastikan tiket keberangkatan dan kepulangan telah tersedia sesuai rencana perjalanan."
},
{
title: "Hotel",
content:
"Pilih hotel sesuai kebutuhan lokasi, kenyamanan, dan anggaran perjalanan Anda."
},
{
title: "Transportasi",
content:
"Persiapkan kebutuhan transportasi selama berada di Makkah, Madinah, dan perjalanan antar kota."
}
];

export default function VisaUmroh() {
const [openWA, setOpenWA] = useState(false);
const [openGuide, setOpenGuide] = useState(null);

const msg = encodeURIComponent(
"Assalamualaikum Baba Tour, saya ingin informasi Visa Umroh."
);

return (
<div className="bg-[color:var(--bg)] min-h-screen">
    <Header />
  {openWA && (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-lg">
            Pilih Konsultan Visa
          </h3>

          <button onClick={() => setOpenWA(false)}>
            <X className="w-5 h-5" />
          </button>
        </div>

        <a
          href={`https://wa.me/6282392156538?text=${msg}`}
          target="_blank"
          rel="noreferrer"
className="block w-full bg-gradient-to-r from-[#B8860B] to-[#D4AF37] text-white text-center rounded-xl py-3 mb-3"
        >
          👤 Konsultan Visa 1
        </a>

        <a
          href={`https://wa.me/62811713309?text=${msg}`}
          target="_blank"
          rel="noreferrer"
className="block w-full bg-gradient-to-r from-[#B8860B] to-[#D4AF37] text-white text-center rounded-xl py-3 mb-3"
        >
         👤 Konsultan Visa 2
        </a>
      </div>
    </div>
  )}

<section className="relative overflow-hidden pt-40 pb-12">
<div className="absolute inset-0 opacity-[0.50] pointer-events-none">
  <img
    src="/images/visa/clocktower-bg.jpg"
    alt=""
    className="absolute right-0 top-0 h-full w-full object-cover"
  />
</div>
<div className="relative z-10 max-w-5xl mx-auto px-6">
      <div className="text-sm uppercase tracking-[0.22em] text-accent font-semibold">
        Layanan Visa Umroh
      </div>

      <h1 className="font-serif-display text-[#8B6B11] text-5xl mt-4">
        Visa Umroh Baba Tour
      </h1>

      <p className="text-muted mt-6 text-lg leading-relaxed">
        Layanan pengurusan Visa Umroh untuk travel, group,
        maupun jamaah yang ingin berangkat secara mandiri.
        Tim Baba Tour akan membantu proses pengajuan hingga
        visa terbit.
      </p>

    </div>
  </section>

  <section className="pb-10">
    <div className="text-center">

      <a
        href="#umroh-mandiri"
className="inline-flex items-center px-8 py-4 rounded-full bg-gradient-to-r from-[#B8860B] to-[#D4AF37] text-white shadow-lg hover:scale-105 transition duration-300"
      >
        Click Disini Untuk Umroh Mandiri
      </a>

    </div>
  </section>

<section className="relative overflow-hidden pt-6 pb-20">
<div className="absolute inset-0 opacity-[0.50] pointer-events-none">
  <img
    src="/images/visa/clocktower-bg.jpg"
    alt=""
    className="absolute left-0 bottom-0 h-full w-full object-cover"
  />
</div>
<div className="relative z-10 max-w-6xl mx-auto px-6">
      <h2 className="text-4xl font-bold text-center text-[#8B6B11] mb-12">
        Harga Visa Group
      </h2>

      <div className="grid grid-cols-2 gap-4">

        <div className="border rounded-2xl p-6 h-full">

          <div className="pb-4 border-b">
            <div className="text-xl font-bold">
              Rp 2.50jt / pax
            </div>
            <div className="text-muted">
              Min 45 pax
            </div>
          </div>

          <div className="py-4 border-b">
            <div className="text-xl font-bold">
              Rp 2.55jt / pax
            </div>
            <div className="text-muted">
              Min 40 pax
            </div>
          </div>

          <div className="pt-4">
            <div className="text-xl font-bold">
              Rp 2.60jt / pax
            </div>
            <div className="text-muted">
              Min 35 pax
            </div>
          </div>

        </div>

        <div className="border rounded-2xl p-5">

          <p className="mb-4">
            Harga Visa merupakan harga yang ditawarkan kepada group atau travel umroh yang ingin mengajukan visa umroh jamaah secara kolektif.
          </p>

          <p className="mb-6">
            Baba Tour akan melayani proses pengajuan visa hingga visa terbit.
          </p>

          <div className="font-semibold mb-3">
            Paket Visa termasuk:
          </div>

          <ul className="space-y-2">
            <li>• Bus 5x Trip</li>
            <li>• Harga asumsi dollar Rp17,850</li>
          </ul>

        </div>

      </div>
<div className="text-center mt-12">

  <button
    onClick={() => setOpenWA(true)}
className="bg-gradient-to-r from-[#B8860B] to-[#D4AF37] text-white px-8 py-4 rounded-full shadow-lg hover:scale-105 transition duration-300"
  >
    Konsultasi Visa Umroh
  </button>

</div>
    </div>
  </section>
<section
  id="umroh-mandiri"
  className="relative overflow-hidden py-20 scroll-mt-32"
>
<div className="absolute inset-0 opacity-[0.50] pointer-events-none">
  <img
    src="/images/visa/clocktower-bg.jpg"
    alt=""
    className="absolute right-0 bottom-0 h-full w-full object-cover"
  />
</div>
<div className="relative z-10 max-w-4xl mx-auto px-6">
      <h2 className="text-4xl font-bold text-center text-[#8B6B11] mb-4">
        Panduan Umroh Mandiri
      </h2>
      <p className="text-center text-muted mb-10">
        Persiapkan perjalanan ibadah Anda dengan lebih tenang melalui panduan berikut.
      </p>
      <div className="space-y-4">

        {guides.map((guide, index) => (
          <div
            key={index}
            className="border rounded-2xl overflow-hidden"
          >
            <button
              onClick={() =>
                setOpenGuide(openGuide === index ? null : index)
              }
              className="w-full flex justify-between items-center p-5 text-left font-medium"
            >
              <span>{guide.title}</span>

              <span className="text-2xl">
                {openGuide === index ? "−" : "+"}
              </span>
            </button>

            {openGuide === index && (
              <div className="px-5 pb-5 text-muted">
                {guide.content}
              </div>
            )}

          </div>
        ))}

      </div>
<div className="text-center mt-12">

  <button
    onClick={() => setOpenWA(true)}
className="bg-gradient-to-r from-[#B8860B] to-[#D4AF37] text-white px-8 py-4 rounded-full shadow-lg hover:scale-105 transition"
  >
    Hubungi Kami
  </button>

</div>
    </div>
  </section>

  <Footer />
</div>
);
}
